import { render } from "./PatientColInline.vue?vue&type=template&id=6f9d9823&scoped=true"
import script from "./PatientColInline.vue?vue&type=script&lang=js"
export * from "./PatientColInline.vue?vue&type=script&lang=js"

import "./PatientColInline.vue?vue&type=style&index=0&id=6f9d9823&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9d9823"]])

export default __exports__